import {LabelLanguage} from "@/models/NutritionLabels/LabelLanguage";
import {SavedAllergen} from "@/models/Allergen/SelectedAllergen";

export interface AllergenConfigurationData {
    allergens: SavedAllergen[];
    mayContainText: Partial<Record<LabelLanguage, string[]>>;
}

export enum AllergenConfigurationTargetType {
    Ingredient = "Ingredient",
    Recipe = "Recipe"
}

export interface SaveAllergenConfigurationRequest extends AllergenConfigurationData {
    targetType: AllergenConfigurationTargetType;
    targetId: number;
}
